exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-client-portal-help-styles__anchor {\n  height: 100%;\n  padding-right: 12px;\n  padding-left: 8px;\n  display: flex;\n  align-items: center;\n}\n\n.src-client-portal-help-styles__spacer {\n  background: var(--cps-color-athens);\n  height: 32px;\n  width: 2px;\n}\n", ""]);

// exports
exports.locals = {
	"anchor": "src-client-portal-help-styles__anchor",
	"spacer": "src-client-portal-help-styles__spacer"
};